import { useParams, useNavigate } from "react-router-dom";
import CoachPage from "../../component/coach-page";

const Coach = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { courseId, coachId = 0 } = params;

  return (
    <CoachPage
      visible
      hideAnswer
      challengeId={Number(coachId)}
      onClose={() => {
        navigate(`/course/${courseId}/catalog`);
      }}
    />
  );
};

export default Coach;
